import React from 'react';
import ReactDOM from 'react-dom';
import './style.css';

import moment from 'moment';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

import { connect } from 'react-redux';

import { updateDate } from '../../actions/page2-actions';
import { updateTimeslot } from '../../actions/page2-actions';
import { updateActiveTimeslot } from '../../actions/page2-actions';
import { updateNextButton } from '../../actions/global-actions';



import Timeslots from '../timeslots';


class Datetimepicker extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			portalContainer: null,
			timeslots: [],
			availableDays: [],
			isLoading: false,
			visibleTimeslots: [],
			selectedDays: [],
		};
	}
	componentDidMount() {
		if (this.props.date !== null) {
			var ariaSelector = moment(this.props.date).format('ddd MMM DD YYYY');
			const day = document.querySelector(`[aria-label="${ariaSelector}"]`);
			if(day !== null) {
				this.setState({
					portalContainer: day.parentElement,
				});
			}
		}

		this.handleMonthChange(moment());
  	}

	handleDayChange(date, event) {
		this.props.updateTimeslot({startTime: null, endTime: null});
		this.props.updateNextButton(false)
		this.props.updateActiveTimeslot([null, null])

		const mDate = moment(date).local();
		const formattedDate = mDate.format('YYYY-MM-DD');
		const startDate = mDate.clone().startOf('week');
		const endDate = mDate.clone().endOf('week');


		const visibleTimeslots = {};
		for (let day = startDate.clone(); day.isSameOrBefore(endDate); day.add(1, 'd')) {
			let localDate = day.format('YYYY-MM-DD');
			visibleTimeslots[localDate] = this.state.timeslots[localDate] || []
		}

		this.setState({
			portalContainer: event.target.parentElement,
			selectedDays: Object
				.keys(visibleTimeslots)
				.map((date) => moment(date).toDate()),
			visibleTimeslots,
		});

		this.props.updateDate(formattedDate);
	}


	handleMonthChange(date) {
		const now = moment().utc();
		const mDate = moment(date).utc();

		const startTimeDate = moment.max(
			now.clone().startOf('day'),
			mDate.clone().startOf('month').subtract(6, 'day')
		);

		const endTimeDate = mDate.clone().endOf('month').add(6, 'day');

		if (now.isAfter(endTimeDate)) {
			this.setState({ 'timeslots': [], isLoading: false });
			return;
		}

		this.setState({ 'isLoading': true });

		fetch(`${process.env.REACT_APP_API_BASE}/api/v1/pages/${process.env.REACT_APP_PAGE_PK}/timeslots/?resource=${process.env.REACT_APP_RESSOURCE_ID}&start=${startTimeDate.toISOString()}&end=${endTimeDate.toISOString()}`, {
			mode: "cors",
		})
			.then(response => response.json())
			.then((data) => Object
				.values(data)
				.reduce((out, timeslots) => [...out, ...timeslots], [])
				.reduce((out, timeslot) => {
					let localDate = moment(timeslot.start).local().format('YYYY-MM-DD')
					if (!Array.isArray(out[localDate]))
						out[localDate] = [];
					out[localDate].push(timeslot)
					return out;
				}, {})
			)
			.then((timeslots => this.setState({
				timeslots, 
				availableDays: Object
					.entries(timeslots)
					.reduce((dates, [date, timeslots]) => {
						let dateAvailable = timeslots.reduce((allAvailable, { available }) => allAvailable || available, false);
						if (dateAvailable)
							dates.push(date)
						return dates;
					}, []),
				isLoading: false,
			})))
			.catch(error => console.error(error))
	}

	dateDisabled(date) {
		return this.state.availableDays.indexOf(moment(date).format('YYYY-MM-DD')) < 0;
	}

	render() {
		const daysAreSelected = this.state.selectedDays.length > 0;
		if(!daysAreSelected) {
			this.props.updateDate(null);
		}

		return (
			<div className="datetimepicker">
				<DayPicker
					showOutsideDays={true}
					disabledDays={(date) => this.dateDisabled(date)}
					modifiers={{
						highlighted: moment(this.props.date).toDate(),
						selectedRange: daysAreSelected && {
							from: this.state.selectedDays[0],
							to: this.state.selectedDays[6],
						},

					}}
					onDayClick={(date, _, event) => this.handleDayChange(date, event)}
					onMonthChange={(date) => this.handleMonthChange(date)}
				/>
				{this.state.portalContainer !== null && ReactDOM.createPortal(
					<Timeslots timeslots={this.state.visibleTimeslots} />, 
					this.state.portalContainer
				)}
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {
		date,
		timeslot,
	} = state.page2;
	const {nextBtn} = state.global;
	return { date, timeslot, nextBtn};
}

export default connect(mapStateToProps, { updateDate, updateActiveTimeslot, updateTimeslot, updateNextButton})(Datetimepicker);